"use strict";
/**
 * Copyright (c) Hathor Labs and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosWrapperCreateRequestInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("../constants");
/**
 * Method that creates an axios instance
 *
 * @module Axios
 */
/**
 * Create an axios instance to be used when sending requests
 *
 * @param {String} url Base URL for the api requests
 * @param {callback} resolve Callback to be stored and used in case of a retry after a fail
 * @param {number} timeout Timeout in milliseconds for the request
 * @param {Object} additionalHeaders Headers to be sent with the request
 */
exports.axiosWrapperCreateRequestInstance = (url, resolve, timeout, additionalHeaders = {}) => {
    if (timeout === undefined) {
        timeout = constants_1.TIMEOUT;
    }
    const defaultOptions = {
        baseURL: url,
        timeout: timeout,
        headers: Object.assign({
            'Content-Type': 'application/json',
        }, additionalHeaders),
    };
    return axios_1.default.create(defaultOptions);
};
exports.default = exports.axiosWrapperCreateRequestInstance;
//# sourceMappingURL=axiosWrapper.js.map